export { MenuAlt2 as default } from './MenuAlt2';
